import React from 'react';
import { useAuth } from '../context/AuthContext';

const withPermission = (WrappedComponent, requiredPermissions=[],requiredModules=[]) => {
    return (props) => {
        const { permissions, roles ,modules} = useAuth();
        const hasRequiredPermission = React.useMemo(() => {
            if (roles.includes('superadmin')) {
                return true; 
            }
           
            const permissionCheck = requiredPermissions.length === 0 || requiredPermissions.some((permission) => permissions.includes(permission));
            
            // Check modules
            const moduleCheck = requiredModules.length === 0 || requiredModules.some((module) => modules.includes(module));

            // Both permission and module must be satisfied
            return permissionCheck && moduleCheck;

        }, [permissions, requiredPermissions, roles, modules, requiredModules]);

      
        if (!hasRequiredPermission) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };
};

export default withPermission;
